import { BaseModel } from './base';

export class Trainingcategory extends BaseModel {
  trainingCategoryName: string;

  subscriberId: string;

  siteId: string;
}
